import api from "./api";

class ReleasesNotesAPI {
  async addNovaReleaseNote(headers, params) {
   const response = await api({
      method: 'post',
      url: '/post_release_notes',
      headers,
      data: params
    });
    return response;
  }

  async getReleaseNotes(headers) {
    const response = await api.get("/get_release_notes", { headers });
    return response;
  }

  async buscarUltimaVersao(headers, params) {
    const response = await api.get("/get_ultima_versao", { headers, params });
    return response;
  }

  async deleteReleaseNotes(headers, params) {
    const response = await api({
      method: 'delete',
      url: 'delete_release_notes',
      headers,
      data: params
    });
    return response;
  }
}

export default new ReleasesNotesAPI();
